export default __webpack_public_path__ + "static/media/support_jump_thumb.441e1557.png";